import { FileTextIcon, ZapIcon, LanguagesIcon, SmartphoneIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Sofortiger Zugriff'
}, {
  icon: LanguagesIcon,
  label: 'Von absolut null an'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: '7-Tage-Garantie'
}, {
  icon: LockIcon,
  label: 'Sichere Zahlung'
}, {
  icon: CreditCardIcon,
  label: 'Kredit- / Debitkarte'
}];
export const stats = [{
  value: '500+',
  label: 'Zufriedene Schüler ⭐'
}, {
  value: '6',
  label: 'Komplette Bände'
}, {
  value: '5',
  label: 'Boni inklusive'
}, {
  value: '4.9/5',
  label: 'Bewertung'
}];